import React, {useState} from "react";
import {axiosRun} from "../utils/axiosWrap";
import {config} from "../config";
import {UploadData} from "./UploadData";

export const UpdateGroupsData = ()=>{
    return <UploadData title={"оновлення даних про групи"} linkUpload={config.apiLinks.uploadGroupsData} />
}
